/*** IMPORTS FROM imports-loader ***/
var define = false;

/* global grecaptcha */

import $ from 'jquery';
import forOwn from 'lodash/forOwn';
import keys from 'lodash/keys';
import * as Ladda from 'ladda';
import moment from 'moment';
import swal from 'sweetalert2';
import { setupPhoneInputs, teardownPhoneInputs } from '../../../shared/widget/phone';

function teardownDatepickers($root) {
  $root.find('.hidden-date').datepicker('destroy');
}

function setupDatepickers($root) {
  $root.find('.hidden-date').each((key, hiddenInput) => {
    const $hiddenInput = $(hiddenInput);
    const $dateInputs = $hiddenInput.closest('.date-inputs');

    // No need for datepicker if the fields are <select> elements
    if ($dateInputs.find('select').length === 3) {
      return;
    }

    const $monthInput = $dateInputs.find('.date-month');
    const $dayInput = $dateInputs.find('.date-day');
    const $yearInput = $dateInputs.find('.date-year');

    const options = {
      format: 'yyyy-mm-dd',
      autoclose: true,
      startDate: -Infinity,
      endDate: Infinity,
      daysOfWeekDisabled: [],
      zIndexOffset: 999999,
    };

    if ($hiddenInput.data('prevent-past')) {
      options.startDate = moment().set({
        hour: 0, minute: 0, second: 0, millisecond: 0,
      }).toDate();
    }

    if ($hiddenInput.data('prevent-future')) {
      options.endDate = moment().set({
        hour: 0, minute: 0, second: 0, millisecond: 0,
      }).toDate();
    }

    const limitStart = $hiddenInput.data('limit-start');
    if (limitStart) {
      options.startDate = moment(limitStart, 'YYYY-MM-DD').toDate();
    }

    const limitEnd = $hiddenInput.data('limit-end');
    if (limitEnd) {
      options.endDate = moment(limitEnd, 'YYYY-MM-DD').toDate();
    }

    const daysOfWeekDisabled = [];
    if ($hiddenInput.data('prevent-monday')) {
      daysOfWeekDisabled.push(1);
    }
    if ($hiddenInput.data('prevent-tuesday')) {
      daysOfWeekDisabled.push(2);
    }
    if ($hiddenInput.data('prevent-wednesday')) {
      daysOfWeekDisabled.push(3);
    }
    if ($hiddenInput.data('prevent-thursday')) {
      daysOfWeekDisabled.push(4);
    }
    if ($hiddenInput.data('prevent-friday')) {
      daysOfWeekDisabled.push(5);
    }
    if ($hiddenInput.data('prevent-saturday')) {
      daysOfWeekDisabled.push(6);
    }
    if ($hiddenInput.data('prevent-sunday')) {
      daysOfWeekDisabled.push(7);
    }
    options.daysOfWeekDisabled = daysOfWeekDisabled;

    const onChangeDate = (ev) => {
      const date = moment(ev.date);
      $monthInput.val(date.format('MM'));
      $dayInput.val(date.format('DD'));
      $yearInput.val(date.format('YYYY'));
    };

    $hiddenInput.datepicker(options).on('changeDate', onChangeDate);

    const onFocus = () => {
      $hiddenInput.datepicker('show');
    };

    $monthInput.on('focus', onFocus);
    $dayInput.on('focus', onFocus);
    $yearInput.on('focus', onFocus);
  });
}

function setupRecaptcha($root) {
  $root.find('.g-recaptcha').each((idx, el) => {
    const $el = $(el);

    grecaptcha.render(el, {
      sitekey: $el.data('sitekey'),
      theme: $el.data('theme'),
      size: $el.data('size'),
    });
  });
}

setupDatepickers($('form.js-dynamic-form'));
setupPhoneInputs();

$(document).on('submit', 'form.js-dynamic-form', (ev) => {
  const $form = $(ev.currentTarget);

  ev.preventDefault();

  const l = Ladda.create($form.find('button[type=submit]')[0]);
  l.start();

  //
  // Uploaders
  //

  const uploaders = $form.data('uploaders');
  let hasUploadErrors = false;
  let hasUploadsInProgress = false;

  const refreshUploadState = () => {
    if (uploaders && uploaders.length) {
      hasUploadErrors = false;
      hasUploadsInProgress = false;
      for (let i = 0; i < uploaders.length; i += 1) {
        const uppy = uploaders[i];
        const state = uppy.getState();
        // eslint-disable-next-line no-loop-func
        forOwn(state.files, (file) => {
          if ('error' in file) {
            hasUploadErrors = true;
            return false;
          }
          if (!('error' in file) && !file.progress.uploadComplete) {
            hasUploadsInProgress = true;
            return false;
          }
          return true;
        });
      }
    }
  };

  if (uploaders && uploaders.length) {
    for (let i = 0; i < uploaders.length; i += 1) {
      const uppy = uploaders[i];
      uppy.upload();
    }

    refreshUploadState();

    if (hasUploadErrors) {
      swal(
        'Error',
        'An upload failed. Please retry or remove from the list and try sending again.',
        'error',
      );
      l.remove();
      return;
    }

    // Will fire immediately. We use a timer below and just show the Ladda spinner on the submit button.
    // if (hasUploadsInProgress) {
    //   swal.fire(
    //     'Uploading',
    //     'Upload still in progress. Wait until finished and try again.',
    //     'error',
    //   );
    //   l.remove();
    //   return;
    // }
  }

  //
  // POST
  //

  const doPost = () => {
    $.ajax({
      type: 'POST',
      url: ev.currentTarget.getAttribute('action'),
      data: $form.serialize(),
      dataType: 'json',
      success: (resp) => {
        if ('html' in resp) {
          teardownDatepickers($form);
          teardownPhoneInputs();
          const $newForm = $($.parseHTML(resp.html));
          $form.replaceWith($newForm);
          $newForm.find('.form-group.error').first().find('input:first, select:first, textarea:first').focus();
          setupDatepickers($newForm);
          setupPhoneInputs();
          setupRecaptcha($newForm);
          $newForm.trigger('submitHandled');
        } else if ('redirect' in resp) {
          window.location = resp.redirect;
        }
      },
    }).always(() => {
      l.remove();
    });
  };

  if (hasUploadsInProgress) {
    let postTimer = null;
    postTimer = setInterval(() => {
      refreshUploadState();
      if (hasUploadsInProgress) {
        return;
      }
      clearInterval(postTimer);
      doPost();
    }, 1000);
  } else {
    doPost();
  }
});

